import { MenuItem } from 'src/app/_models/classes/common';

export const MENU_ITEMS: MenuItem[] = [
  {
    path: '/upload',
    label: 'upload.title',
    icon: 'cloud_upload'
  },
  {
    path: '/example/view-imported-data',
    label: 'database',
    icon: 'storage'
  }
];
